// extracted by mini-css-extract-plugin
module.exports = {"ContactForm":"ContactForm_ContactForm__34mpF","BtnsRow":"ContactForm_BtnsRow__2Jc6w","DirectMsg":"ContactForm_DirectMsg__3XcgI"};